import React from 'react';
import a from '../../assets/Frame-100-1-450x550.jpg';
import aa from '../../assets//Frame-103-1-450x550.jpg';
import aaa from '../../assets/Frame-107-450x550.jpg';
import aaaa from '../../assets/Frame-93-450x550.jpg';
import aaaaa from '../../assets/Frame-98-450x550.jpg';
import aaaaaa from '../../assets/Frame-99-450x550.jpg';
import x from '../../assets/01-6-450x550.jpg';
import z from '../../assets/04-2-450x550.jpg';
import vv from '../../assets/01-9-450x550.jpg';
import vvv from '../../assets/04-7-450x550.jpg';
import vvvv from '../../assets/01-7-450x550.jpg';
import vvvvv from '../../assets/01-4-450x550.jpg';
import c from '../../assets/01-8-450x550.jpg';
import { PiStarFill, PiStarHalfFill } from 'react-icons/pi';
import { BsDot } from 'react-icons/bs';
import { BsSearch } from 'react-icons/bs';
import w from '../assets/fashion-girl-posing-studio-wearing-smart-casual-sportive-outfit-business-style-sweet-pastel-colors-sunglasses-backpack-denim-jacket-mint-background-stylish-woman.jpg';
import ww from '../assets/pexels-luis-leon-2569241.jpg';
import { GrFormNext } from 'react-icons/gr';

const Products = () => {
  return (
    <div className='py-[4rem] lg:px-[6rem] px-4 md:px-0'>
        <div className='container mx-auto'>
            <div className='lg:flex justify-center items-start'>
                {/* products */}
                <div className='grid xl:grid-cols-3 md:grid-cols-2 w-full gap-4'>
                <div className='w-full'>
                  <img src={a} alt=""/>
                  <div className=' flex justify-between items-center font-ma w-[100%] md:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={aa} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={aaa} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={aaaa} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={aaaaa} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={aaaaaa} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={vv} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={vvv} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={vvvv} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                          <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={vvvv} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={vvvv} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={vvvvv} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={x} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={z} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <img src={c} alt=""/>
                  <div className=' flex justify-between items-center font-ma md:w-full sm:w-[75%] lg:w-auto'>
                    <div className=''>
                        <h5 className='font-semibold text-[18px]'>Denim Dress</h5>
                        <h5>Clothing</h5>
                    </div>
                    <div className='flex flex-col justify-end items-end'>
                        <h5 className='text-[20px]'>$125</h5>
                        <div className='flex'>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarFill className='text-[#c4704b]'/>
                           <PiStarHalfFill className='text-[#c4704b]'/>
                        </div>
                    </div>
                  </div>
                </div>
                {/* next page */}
                <div className='flex justify-center items-center 2xl:ml-80 xl:ml-48 xl:pl-32 xl:pt-20 lg:pt-52 md:pt-96 md:mt-52 pt-12 xl:mt-0 md:pr-96 xl:pr-0 pb-12  xl:pb-0 space-x-2 w-full'>
                  <button className='bg-[#fafafa] px-4 py-2 border hover:bg-[#c4704b] hover:text-white transition-all'>1</button>
                  <button className='bg-[#fafafa] px-4 py-2 border hover:bg-[#c4704b] hover:text-white transition-all'>2</button>
                  <a href="">
                    <GrFormNext size={41} className='bg-[#fafafa] border py-2 hover:bg-[#c4704b] hover:text-white transition-all'/>
                  </a>
                </div>
                </div>
                {/* categories */}
                <div className='lg:w-[40%] flex flex-col lg:pl-8'>
                    {/* Product Categories */}
                    <div className='bg-[#fafafa] lg:px-8 py-12 md:pl-8'>
                        <h3 className='text-[23px] font-ma'>Product <span className='text-[#c4704b]'>Catagories</span></h3>
                        <ul className='space-y-4 font-cc pt-6 text-[18px] text-gray-600'>
                            <li className='cursor-pointer hover:text-[#c4704b] transition-all'>Accessories (7)</li>
                            <li className='cursor-pointer hover:text-[#c4704b] transition-all'>Bags (3)</li>
                            <li className='cursor-pointer hover:text-[#c4704b] transition-all'>Clothing (1)</li>
                            <li className='cursor-pointer hover:text-[#c4704b] transition-all'>Jewellery (5)</li>
                            <li className='cursor-pointer hover:text-[#c4704b] transition-all'>Shoes (4)</li>
                            <li className='cursor-pointer hover:text-[#c4704b] transition-all'>T-shirts (9)</li>
                        </ul>
                    </div>
                    {/* Top Rated Products */}
                    <div className='bg-[#fafafa] px-8 py-12 my-12'>
                        <h3 className='text-[23px] font-ma'>Top Rated <span className='text-[#c4704b]'>Products</span></h3>
                        <div className='font-ma flex justify-start items-center'>
                            <div className='w-[40%]'>
                               <img src={aa} alt="" /> 
                            </div>
                            <div>
                                <h5>Denim Dress</h5>
                                <div className='flex'>
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarHalfFill />
                                </div>
                                <span>$99</span>
                            </div>
                        </div>
                        <div className='font-ma flex justify-start items-center'>
                            <div className='w-[40%]'>
                               <img src={aaa} alt="" /> 
                            </div>
                            <div>
                                <h5>Denim Dress</h5>
                                <div className='flex'>
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarHalfFill />
                                </div>
                                <span>$355</span>
                            </div>
                        </div>
                        <div className='font-ma flex justify-start items-center'>
                            <div className='w-[40%]'>
                               <img src={vv} alt="" /> 
                            </div>
                            <div>
                                <h5>Denim Dress</h5>
                                <div className='flex'>
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarHalfFill />
                                </div>
                                <span>$112</span>
                            </div>
                        </div>
                        <div className='font-ma flex justify-start items-center'>
                            <div className='w-[40%]'>
                               <img src={x} alt="" /> 
                            </div>
                            <div>
                                <h5>Denim Dress</h5>
                                <div className='flex'>
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarFill />
                                   <PiStarHalfFill />
                                </div>
                                <span>$399</span>
                            </div>
                        </div>
                    </div>
                    {/* Product Tags */}
                    <div className='bg-[#fafafa] px-8 py-12 font-cc text-gray-600'>
                        <h3 className='text-[23px] font-ma'>Product <span className='text-[#c4704b]'>Tags</span></h3>
                        <div className='flex justify-start items-center pt-4'>
                            <div>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Bag</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Denim One Piece</a>
                            </div>
                            <div className='flex justify-start items-center w-'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Girls Bag</a>
                            </div>          
                        </div>
                        <div className='flex justify-start items-center'>
                        <div>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Handbag</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Hill Shoes</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Jacket</a>
                            </div>
                            <div className='flex justify-start items-center w-'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Joggers</a>
                            </div>
                        </div>
                        <div className='flex justify-start items-center'>
                        <div>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Jogger Trousers</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Ladies Bag</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Line</a>
                            </div>
                        </div>
                        <div className='flex justify-start items-center'>
                        <div>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Men's Watch</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Ring</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Shoes</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'> Suit</a>
                            </div>
                        </div>
                        <div className='flex justify-start items-center'>
                        <div>
                              <a href="" className='hover:text-[#c4704b] transition-all'>Sun Glasses</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'>  T-Shirt</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'>  Top</a>
                            </div>
                            <div className='flex justify-start items-center'>
                              <BsDot size={25} className='text-[#c4704b]'/>
                              <a href="" className='hover:text-[#c4704b] transition-all'>  Watch</a>
                            </div>
                        </div>
                    </div>
                    {/* Search*/}
                    <div className='bg-[#fafafa] px-8 py-12 my-12'>
                      <h3 className='text-[23px] font-ma mb-6'>Search</h3>
                      <div className='flex justify-end items-end'>
                        <input type="text" placeholder='Search products...' className='bg-transparent focus:outline-none w-full border-b border-gray-500 pb-2'/>
                        <BsSearch size={30} className='cursor-pointer absolute pb-2'/>
                      </div>
                    </div>
                    {/* img */}
                    <div className='bg-[#fafafa] px-8 py-8 mb-12'>
                      <a href="">
                        <img src={w} alt="" className='cursor-pointer'/>
                      </a>
                    </div>
                    {/* img */}
                    <div className='bg-[#fafafa] px-8 py-8 '>
                      <a href="">
                        <img src={ww} alt="" className='cursor-pointer'/>
                      </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Products